import { Container, Typography, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <Container sx={{ py: { xs: 6, md: 8 }, px: { xs: 2, sm: 3 }, textAlign: 'center' }}>
      <Typography variant="h2" sx={{ fontWeight: 800, mb: 2, fontSize: { xs: '3rem', md: '4.5rem' } }}>404</Typography>
      <Typography sx={{ color: 'text.secondary', mb: 3 }}>Page not found</Typography>
      <Box>
        <Button component={Link} to="/" variant="contained">Back to Home</Button>
      </Box>
    </Container>
  );
}
